import * as React from 'react';

export const GenerateQuestionsIcon = (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="16" y="7" width="49" height="64" rx="4" fill="#E4FBFF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 6C10 3.23858 12.2386 1 15 1H56C58.7614 1 61 3.23858 61 6V62C61 64.7614 58.7614 67 56 67H15C12.2386 67 10 64.7614 10 62V6ZM15 3C13.3431 3 12 4.34315 12 6V62C12 63.6569 13.3431 65 15 65H56C57.6569 65 59 63.6569 59 62V6C59 4.34315 57.6569 3 56 3H15ZM17 12C17 11.4477 17.4477 11 18 11H53C53.5523 11 54 11.4477 54 12C54 12.5523 53.5523 13 53 13H18C17.4477 13 17 12.5523 17 12ZM18 18C17.4477 18 17 18.4477 17 19C17 19.5523 17.4477 20 18 20H45C45.5523 20 46 19.5523 46 19C46 18.4477 45.5523 18 45 18H18Z"
      fill="#0099C7"
    />
    <path
      d="M38.4305 41.7187C38.6122 41.1703 39.3878 41.1703 39.5695 41.7187L40.7662 45.3298C41.0644 46.2296 41.7704 46.9356 42.6702 47.2338L46.2813 48.4305C46.8297 48.6122 46.8297 49.3878 46.2813 49.5695L42.6702 50.7662C41.7704 51.0644 41.0644 51.7704 40.7662 52.6702L39.5695 56.2813C39.3878 56.8297 38.6122 56.8297 38.4305 56.2813L37.2338 52.6702C36.9356 51.7704 36.2296 51.0644 35.3298 50.7662L31.7187 49.5695C31.1703 49.3878 31.1703 48.6122 31.7187 48.4305L35.3298 47.2338C36.2296 46.9356 36.9356 46.2296 37.2338 45.3298L38.4305 41.7187Z"
      fill="#FF753F"
    />
    <path
      d="M29.7212 34.702C29.8214 34.4497 30.1786 34.4497 30.2788 34.702L31.2277 37.0914C31.5327 37.8592 32.1408 38.4673 32.9086 38.7723L35.298 39.7212C35.5503 39.8214 35.5503 40.1786 35.298 40.2788L32.9086 41.2277C32.1408 41.5327 31.5327 42.1408 31.2277 42.9086L30.2788 45.298C30.1786 45.5503 29.8214 45.5503 29.7212 45.298L28.7723 42.9086C28.4673 42.1408 27.8592 41.5327 27.0914 41.2277L24.702 40.2788C24.4497 40.1786 24.4497 39.8214 24.702 39.7212L27.0914 38.7723C27.8592 38.4673 28.4673 37.8592 28.7723 37.0914L29.7212 34.702Z"
      fill="#FF753F"
    />
  </svg>
);
